import localforage from "localforage";

// Keep camera state in one explicitly configured IndexedDB instance. The app
// previously configured localforage after boot, while camera recovery reads at
// boot; that ordering meant the reader and writer could use different stores.
export const cameraStorage = localforage.createInstance({
  driver: localforage.INDEXEDDB,
  name: "matkaanPhotos",
  version: 1.0,
  size: 100 * 1024 * 1024,
  storeName: "matkaanPhotos",
  description: "Temporary photo storage until uploaded",
});
